module.exports = __webpack_public_path__ + "__static/site-1784740481084/media/chicken-sound.93ab6ed7.mp4";